import React from "react";

const ModelBuilder = ({
  width = 17,
  height = 26,
  viewBox = "0 0 26 17",
  className = "",
  color = "#000"
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={viewBox}
    className={className}
  >
    <g
      fill="none"
      fillRule="evenodd"
      stroke={color}
      strokeLinecap="round"
      strokeWidth="2"
      transform="translate(1.5 1)"
    >
      <line x2="19" y1=".5" y2=".5" />
      <line x1="2" x2="21" y1="7.5" y2="7.5" />
      <line x1="4" x2="23" y1="14.5" y2="14.5" />
    </g>
  </svg>
);

export default ModelBuilder;
